import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getAttribute, updateAttribute } from '../actions/AttributeActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import AttributeForm from '../components/AttributeForm';

import Configuration from '../Config';

const validation = Configuration.Validations.editAttribute;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditAttribute extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getAttribute(this.id));
    }

    handleSave = (values) => {
        this.props.dispatch(updateAttribute(this.props.attribute.id, values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/attributes">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista utilizatori
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16}>
                        <Link to={`/attributes/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Atribut - <strong>{this.props.attribute.name}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <AttributeForm 
                            isEdit={true}
                            initialValues={this.props.attribute}
                            validationSchema={validation}
                            roles={this.props.roles}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.attributes.errors.type === 'validation' ? mapValidationErrors(state.attributes.errors.fields): [],
        attribute: state.attributes.current
    }
}

export default connect(mapStateToProps)(EditAttribute);